import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { SearchItem } from '@/pages/menu-managements/services/searchItem';
import { MenuManagementBrandCategoryService } from '@/services/BrandCategory/MenuManagementBrandCategoryService';

export type SearchCategoryParams = {
  associate_brand_id: string;
  title: string;
};

export const useMenuManagementSearchBrandCategories = async (
  params: SearchCategoryParams
): Promise<SearchItem[]> => {
  const menuManagementBrandCategoryService =
    new MenuManagementBrandCategoryService(getClient());
  try {
    return await menuManagementBrandCategoryService.search(params);
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
